import { render, staticRenderFns } from "./OriginSkillsSection.vue?vue&type=template&id=ade7f128&scoped=true&"
import script from "./OriginSkillsSection.vue?vue&type=script&lang=js&"
export * from "./OriginSkillsSection.vue?vue&type=script&lang=js&"
import style0 from "./OriginSkillsSection.vue?vue&type=style&index=0&id=ade7f128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade7f128",
  null
  
)

export default component.exports